<template>
    <div class="headersMain">
      <div  class="headers" :style="{ 'color':this.isActive == true ? '#FFFFFF' : '#515a6e','background-color':this.isActive == false ? '#FFFFFF' : '#515a6e' }"  v-if="electronicEquipment">
        <div class="head-cen" style="font-family:'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 微软雅黑, Arial, sans-serif;font-size: 14px">
            <div  :class="{ 'heade-left': isActive, 'heade-left2': !isActive }"  >
                <ul>
                    <li @click="signIn">签到</li>
                    <li @click="openExchange">兑换码</li>
                    <li @click="openSetEject">出售设置</li>
                    <li @click="PlanEject = true">排行榜</li>
                    <li @click="openOrganize">组队</li>
                    <li @click="openPindao">频道</li>
                    <li @click="RackingEject = true" >
                      任务榜单  <Badge text="hot" />
                    </li>
                    <li @click="openPets">真 灵</li>
                    <li @click="openTradingBankEject()">黑市</li>
                    <li @click="openLockDemonTowerEject()">秘境</li>
                    <li @click="openSect">宗门</li>
                    <li @click="openforge">锻造</li>
                    <li ><a href="https://docs.qq.com/aio/DWXljb05OUXRmSFl0?p=xWpQddFTRqvpoymhLAbQSL" target="_blank"  >帮助 <Badge text="hot" /></a></li>
                    <li @click="openStrategy">更新日志</li>
                    <li @click="changePas">修改密码</li>
                    <li @click="openSelectChara">切换</li>
                </ul>
            </div>
            <div class="heade-right" >
                <ul>
                    <li @click="out">退出登录</li>
                </ul>
            </div>
        </div>
      </div>
       <div class="head-cen2" v-if="!electronicEquipment">
          <div>
            <Dropdown trigger="click" placement="bottom-start" >
              <Badge >
                <a href="javascript:void(0)" style="font-size: 18px;color: #8b9499">
                  ✿ 快捷菜单 ✿
                </a>
              </Badge>

              <template #list>
                <DropdownMenu>
                  <DropdownItem @click.native="signIn">签到</DropdownItem>
                  <DropdownItem @click.native="openExchange">兑换码</DropdownItem>
                  <DropdownItem @click.native="openSetEject">出售设置</DropdownItem>
                  <DropdownItem @click.native="PlanEject = true">排行榜</DropdownItem>
                  <DropdownItem @click.native="openOrganize">组队</DropdownItem>
                  <DropdownItem @click.native="openPindao">频道</DropdownItem>
                  <DropdownItem @click.native="RackingEject = true" >
                    任务榜单  <Badge text="hot" />
                  </DropdownItem>
                  <DropdownItem @click.native="openPets">真 灵</DropdownItem>
                  <DropdownItem @click.native="openTradingBankEject()">黑市</DropdownItem>
                  <DropdownItem @click.native="openLockDemonTowerEject()">秘境</DropdownItem>
                  <DropdownItem @click.native="openSect">宗门</DropdownItem>
                  <DropdownItem @click.native="openforge">锻造</DropdownItem>
                  <DropdownItem ><a href="https://docs.qq.com/aio/DWXljb05OUXRmSFl0?p=z8LN4Q2RXIfHvLHgxYz63i" target="_blank" >帮助 <Badge text="hot" /></a></DropdownItem>
                  <DropdownItem @click.native="openStrategy">更新日志</DropdownItem>
                  <DropdownItem @click.native="changePas">修改密码</DropdownItem>
                  <DropdownItem @click.native="openSelectChara">切换</DropdownItem>
                  <DropdownItem @click.native="out">退出登录</DropdownItem>
                </DropdownMenu>
              </template>
            </Dropdown>
          </div>
        </div>
        <!-- 真灵 -->
        <Modal width="720" title="真灵" v-model="PetsEject" :styles="{ top: '100px'  }">
          <Tabs v-if="PetsList" :value="Pets" @click.native="cs">
            <TabPane v-for="item in PetsList" :key="item.auraId" :label="
              item.auraStatus == 1 ? item.auraName + '(出战中）' : item.auraName
            " :name="item.auraId">
              <div class="PetsListC">
                <img :src="item.auraIcon" alt="等待图片加载ing" style="width: 160px; height: 160px" />
                <!--                            <p class="touxiang" :style="{ backgroundImage: 'url(' + item.auraIcon + ')' }"></p>-->
                <Row >
                  <Col span="12" >真灵等级:{{ item.auraLevel }}</Col>
                  <Col span="12" >经验:{{ item.auraExp }} / {{ item.auraUpgradeExp }} </Col>
                </Row>
                <br>
                <Row>
                  <Col span="8">状态:{{ PetsStatus(item.auraStatus) }} </Col>
                  <Col span="8">品级:{{ PetsGrade(item.auraGrade) }} </Col>
                  <Col span="8">资质:{{ item.auraAptitude }} </Col>
                </Row>
                <br>
                <Row>
                  <Col span="8">元素:{{ petsEl(item.auraElement) }}</Col>
                  <Col span="8">类型:{{ petsType(item.auraType) }} </Col>
                  <Col span="8">种族:{{ item.auraRace }} </Col>
                </Row>
                <Row>
                  <Col span="24" style="height: 68px">描述:{{ item.auraDesci }}</Col>
                </Row>
                <div>
                  <Row>
                    <Col span="8">力道:{{ item.auraDexterity || 0 }}  </Col>
                    <Col span="8">根骨:{{ item.auraPhysique || 0 }}  </Col>
                    <Col span="8">灵力:{{ item.auraSpirit || 0 }}  </Col>
                  </Row>
                  <Row>
                    <Col span="8">灵力攻击:{{ item.auraMagicAttack || 0 }}  </Col>
                    <Col span="8">力道攻击:{{ item.auraAttack || 0 }}  </Col>
                    <Col span="8">生命值:{{ item.auraLife || 0 }}  </Col>
                  </Row>
                  <Row>
                    <Col span="8">物理防御力:{{ item.auraDefence || 0 }}  </Col>
                    <Col span="8">法术防御力:{{ item.auraMagicDefence || 0 }}  </Col>
                    <Col span="8">真气值:{{ item.auraMana || 0 }}  </Col>
                  </Row>
                  <Row>
                    <Col span="6">命中率:{{  (item.auraHitRate * 100).toFixed(1) || 0 }}  </Col>
                    <Col span="6">闪避率:{{ (item.auraEvade * 100).toFixed(1) || 0 }}  </Col>
                    <Col span="6">暴击:{{  (item.auraExplode * 100).toFixed(1) || 0 }}  </Col>
                    <Col span="6">暴击伤害:{{ (item.auraCalDamage * 100).toFixed(1) || 0  }}  </Col>
                  </Row>
                  <Row>
                    <Col span="24">速度:{{ item.auraActionSpeed || 0 }}  </Col>
                  </Row>
                  <Row>
                    <Col span="24">真灵神通: <span v-for="k in item.gamePetSKillList" :key="k">
                                        <Poptip  width="400" word-wrap trigger="hover">
                                           {{ k.skillName }}
                                            <div slot="content" >
                                              <p>描述: {{k.skillDesc}}</p>
                                              <span>真气: {{k.conMana}}</span>
                                            </div>
                                        </Poptip>
                                    </span></Col>
                  </Row>
                  <!--                              <Tag type="error"  color="primary"></Tag>-->
                  </p>
                </div>
              </div>

              <div class="petsbtn">
                <Button  size="small" @click="ReleaseZhen(item)">
                  放生
                </Button>
                <Button  size="small" @click="goToWar(item)">
                  出战/休息
                </Button>
              </div>
            </TabPane>
          </Tabs>
          <div slot="footer">
            <Button type="dashed" size="small" @click="PetsEject = false">
              取消
            </Button>
          </div>
        </Modal>

        <!-- 组队 -->
        <Modal width="720" :title="organizeList.armyName ? organizeList.armyName : '组队'" v-model="organizeEject" :styles="{ top: '100px' }" class="organizeEject">
          <div v-for="(item, idx) in organizeList.charaInfoVoList" :key="idx" class="organizeList">
            <div v-if="item.avatar" style="position: relative; float: left">
              <img :src="item.avatar" alt="老弟,没图片找群主要啊" class="organizeList_face" />
              <span @click="kickOut(item)" v-if="item.status == 0">
                            <Icon type="md-close" style=" font-family:Ionicons" />
                        </span>
            </div>
            <div v-else style="
              text-align: center;
              font-size: 60px;
              cursor: pointer;
              position: relative;
              float: left;
            ">
              <Icon type="ios-body" class="organizeList_face" />

              <span @click="kickOut(item)" v-if="item.status == 0">
                            <Icon type="md-close" style=" font-family:Ionicons" />
                        </span>
            </div>
            <p class="organizeList_name" v-if="item.charaName">
              {{ item.charaName }} {{ item.charaLevel }} 级 副本剩余次数: {{item.rewardNum}}
            </p>
          </div>
          <Select v-model="mapName">
            <!-- ({{ item.minLv }}) -->
            <Option v-for="item in mapList" :value="item.mapName" :name="item.mapId" :key="item.mapId">
              {{ item.mapName }}{{ item.minLv }}-{{ item.maxLv }}
            </Option>
          </Select>
          <Button @click="CombatRecord()" :loading="recordStatus" style="margin-top: 10px">
            战斗记录
          </Button>
          <template v-if="combatRecordProcess">
            <p v-for="(item, idx) in combatRecordProcess" :key="item.reHealth" style="font-size: 18px; margin: 5px 0">
              第{{ ++idx }}场战斗
              <span style="color: red">
                            {{ combatRecordProcess.length == idx ? "失败" : "胜利" }}
                        </span>
              剩余 {{ item.reHealth }}血量 剩余 {{ item.reMana }}真气 获取
              {{ item.dropExp }} 经验 物品: {{ item.gameItemsList1 || "空" }}
            </p>
          </template>
          <div slot="footer" style="font-family:Helvetica">
            <Button type="circle" style="font-size: 12px;background-color: #00adff;color: #ffffff"  @click="join" v-if="teamStatus == 0">
              队伍列表
            </Button>
            <Button type="circle" style="font-size: 12px;background-color: #00adff;color: #ffffff"   @click="establish" v-if="teamStatus == 0">
              创建队伍
            </Button>
            <Button type="circle" style="font-size: 12px;background-color: #00adff;color: #ffffff"   @click="quitTheTeam" v-if="teamStatus == 1">
              退出队伍
            </Button>
          </div>
        </Modal>
        <!-- 捐献提示框 选择装备 -->
        <Modal v-model="donateEject" title="捐献选择装备" @on-ok="changeSmelt()" :styles="{ top: '100px' }">
          <Radio-group v-model="packItemId">
            <Radio v-for="(item, index) in checkboxList" :key="index" :label="item.packItemId" style="color: red">
              {{ item.itemName }}  品阶 {{item.scoreLevel}}
            </Radio>
          </Radio-group>

        </Modal>
        <Modal v-model="releaseEject" title="放生" @on-ok="Release">
          <p>确认要放生真灵吗？</p>
        </Modal>
        <Modal v-model="exitSectEject" title="退出" @on-ok="deleTheSect">
          <p>退出宗门将清空所有贡献,是否退出</p>
        </Modal>
        <!-- 宝阁提示框 选择装备 -->
        <modal width="320px"   v-model="itemEject2" footer-hide="true" :styles="{ top: '100px' }">
          <div style="z-index:200;">
            <p :style="{ color: distinguishColor(item.color) }">
              {{ item.itemName }}
              <br>
              <span style="color: blue "  v-if="item.basicSocre != null ">
                灵气 ☪<label>{{item.basicSocre }}+{{item.appraisaScore }}</label>  <br> 品阶 {{item.scoreLevel}}
                                            </span>
            </p>
            <p>强化上限 <label style="color: darkred">{{  item.maxStrengthen }}</label></p>
            <p>洗练上限 <label style="color: darkred">{{ item.appraisalNum }}</label></p>
            <p>装备类型  <span style="color: #2e8bf0 ">{{ item.typeDec }}</span></p>
            <p>法器元素 <span style="color: #2e8bf0 ">{{ item.weaponTypeDec }}</span></p>
            <p>装备等级 <label style="color: darkred">{{ item.level }}</label></p>
            <!--              <p>物品状态 {{ item.bind == 0 ? "解绑" : "绑定" }}</p>-->
            <p>鉴定状态  <span style="color: #2e8bf0 ">{{ item.appraisal == 1 ? "已鉴定" : "未鉴定" }}</span></p>
            <p v-if="item.life" class="discrimination">
              生命值 <label style="color: darkred">{{ item.life }} ({{item.lifeRandom}})</label>
              <span v-if="item.strengLife">
                                                ({{ item.strengLife }})
                                            </span>
            </p>
            <p v-if="item.mana" class="discrimination">
              真气值 <label style="color: darkred">{{ item.mana }} ({{item.manaRandom}})</label>
              <span v-if="item.strengMana">
                                                ({{ item.strengMana }})
                                            </span>
            </p>
            <p v-if="item.attack" class="discrimination">
              攻击力 <label style="color: darkred">{{ item.attack }} ({{item.attackRandom}})</label>
              <span v-if="item.strengAttack">
                                                ({{ item.strengAttack }})
                                            </span>
            </p>
            <p v-if="item.magAttack" class="discrimination">
              法术攻击力 <label style="color: darkred">{{ item.magAttack }} ({{item.magAttackRandom}})</label>
              <span v-if="item.strengMagAttack">
                                                ({{ item.strengMagAttack }})
                                            </span>
            </p>
            <p v-if="item.defense" class="discrimination">
              物理防御力 <label style="color: darkred">{{ item.defense }} ({{item.defenseRandom}})</label>
              <span v-if="item.strengDefense">
                                                ({{ item.strengDefense }})
                                            </span>
            </p>
            <p v-if="item.magicDefense" class="discrimination">
              法术防御力 <label style="color: darkred">{{ item.magicDefense }} ({{item.magicDefenseRandom}})</label>
              <span v-if="item.strengMagicDefense">
                                                ({{ item.strengMagicDefense }})
                                            </span>
            </p>
            <p v-if="item.hitRate" class="discrimination">
              命中率 <label style="color: #801DAE">{{ (item.hitRate * 100).toFixed(2) }}% ({{item.hitRateRandom}})</label>
            </p>
            <p v-if="item.evade" class="discrimination">
              闪避率 <label style="color: #801DAE">{{ (item.evade * 100).toFixed(2) }}% ({{item.evadeRandom}})</label>
            </p>
            <p v-if="item.critical" class="discrimination">
              暴击率 <label style="color: #801DAE">{{ (item.critical * 100).toFixed(2) }}% ({{item.criticalRandom}})</label>
            </p>
            <p v-if="item.criDamage" class="discrimination">
              暴击伤害 <label style="color: #801DAE">{{ (item.criDamage * 100).toFixed(2) }}% ({{item.criDamageRandom}})</label>
            </p>
            <p v-if="item.speed" class="discrimination">
              行动速度 <label style="color: #d88228">{{ item.speed }} ({{item.speedRandom}})</label>
            </p>
            <p v-if="item.physique" class="discrimination">
              根骨 <label style="color: #d88228">{{ item.physique }} ({{item.physiqueRandom}})</label>
              <span v-if="item.strengPhysique">
                                                ({{ item.strengPhysique }})
                                            </span>
            </p>
            <p v-if="item.dexterous" class="discrimination">
              力道 <label style="color: #d88228">{{ item.dexterous }} ({{item.dexterousRandom}})</label>
              <span v-if="item.strengDexterous">
                                                ({{ item.strengDexterous }})
                                            </span>
            </p>
            <p v-if="item.spirit" class="discrimination">
              灵力 <label style="color: #d88228">{{ item.spirit }} ({{item.spiritRandom}})</label>
              <span v-if="item.strengSpirit">
                                                ({{ item.strengSpirit }})
                                            </span>
            </p>
            <Divider v-if="item.affixVoList" />
            <template v-if="item.affixVoList">
              <p v-for="cz in item.affixVoList" :key="cz.affixDescribe" :style="{
                          color:
                            cz.affixLevel == 'T1'
                              ? '#ff8c00'
                              : 'rgb(73, 193, 248)',
                        }">
                【{{ cz.affixLevel }}】 {{ cz.affixDescribe }}
              </p>
            </template>
            <Divider v-if="item.decs" />
            <p v-if="item.decs">描述： {{ item.decs }}</p>
            <p v-if="item.suitName">共鸣名字: {{ item.suitName }}</p>
            <p v-if="item.suitOneDesc">共鸣效果: {{ item.suitOneDesc }}</p>
            <p v-if="item.suitDesc">共鸣描述: {{ item.suitDesc }}</p>
            <Divider v-if="item.skillDesc" />
            <p v-if="item.skillDesc">神通描述： {{ item.skillDesc }}</p>
            <Divider v-if="item.player" />
            <!--              <p v-if="item.player" ><Icon type="ios-navigate" /> 宗门：{{ item.player }}</p>-->
            <p v-if="item.player" ><Icon type="ios-navigate" style=" font-family:Ionicons" color="darkred"/> 贡献者：{{ item.player }}</p>
            <p v-if="item.contriPoint"><Icon type="ios-pricetags-outline" style=" font-family:Ionicons" color="darkred"/> 贡献点：{{ item.contriPoint }}</p>
          </div>
        </modal>
        <!-- 图纸提示    -->
        <modal width="420px" style="font-family: STXinWei;"   v-model="tzitemEject2" footer-hide="true" :styles="{ top: '100px' }">
          <List  border size="small"  >
            <ListItem>图纸编号： {{  formulaVo.drawing }}</ListItem>
            <ListItem>图纸名称：  {{  formulaVo.name }}</ListItem>
            <ListItem>图纸描述：  {{  formulaVo.desci }}</ListItem>
            <ListItem>消耗灵石：  {{  formulaVo.costCoin }}</ListItem>
            <!--              <p>物品状态 {{ item.bind == 0 ? "解绑" : "绑定" }}</p>-->
            <ListItem>锻造时间(秒)：  {{  formulaVo.costTime }}</ListItem>
            <ListItem>图纸基础打造成功率：  {{  (formulaVo.basicRate * 100).toFixed(2) || 0 }}%</ListItem>
            <ListItem>图纸材料打造成功率：  {{  (formulaVo.caiRate * 100).toFixed(2) || 0 }}%</ListItem>
            <ListItem>是否满足：  {{  formulaVo.isMeet  == true ? "满足" : "不满足"  }}</ListItem>
            <ListItem><Divider v-if="formulaVo.matList">配方材料列表</Divider></ListItem>
            <template v-if="formulaVo.matList">
              <!--              cz in formulaVo.matList   -->
              <ListItem v-for="(cz, index) in formulaVo.matList" :key="cz.itemName" >
                【{{ cz.type == 1 ? "主材料" : "辅材料" }}】{{ cz.itemName }}： {{ cz.haveNum }}/{{ cz.num }}
                <Input v-if="cz.type != 1" style="width: 50px;padding-left: 10px"  v-model="itemFucaiNum[index]" @on-change="getmatList(cz.itemId,index)" placeholder="默认所有" />
              </ListItem>
            </template>
            <Button v-if="formulaVo.isMeet == true" type="success" style="position: relative;left: 80%;margin-top: 4px;margin-bottom: 5px"  @click="duanzao()">锻造</Button>
          </List>
          <!--            <div style="z-index:200;">
                        <p>图纸编号： {{  formulaVo.drawing }}</p>
                        <p>图纸名称：  {{  formulaVo.name }}</p>
                        <p>图纸描述：  {{  formulaVo.desci }}</p>
                        <p>消耗灵石：  {{  formulaVo.costCoin }}</p>
                        &lt;!&ndash;              <p>物品状态 {{ item.bind == 0 ? "解绑" : "绑定" }}</p>&ndash;&gt;
                        <p>锻造时间(秒)：  {{  formulaVo.costTime }}</p>
                        <p>图纸基础打造成功率：  {{  (formulaVo.basicRate * 100).toFixed(2) || 0 }}%</p>
                        <p>图纸材料打造成功率：  {{  (formulaVo.caiRate * 100).toFixed(2) || 0 }}%</p>
                        <p>是否满足：  {{  formulaVo.isMeet  == true ? "满足" : "不满足"  }}</p>
                        <Divider v-if="formulaVo.matList" />
                        <template v-if="formulaVo.matList">
                          <p v-for="cz in formulaVo.matList" :key="cz.itemName" >
                            【{{ cz.type == 1 ? "主材料" : "辅材料" }}】{{ cz.itemName }}： {{ cz.haveNum }}/{{ cz.num }}
                          </p>
                        </template>
                      </div>-->
        </modal>
        <!-- 宗门 -->
        <Modal width="824" style="font-family: STXinWei;"  :title="sectList.name ? sectList.name : '宗门'" v-model="sectEject" :styles="{ top: '100px' }" class="organizeEject">
          <!--  宗门列表   -->
          <List item-layout="vertical" v-model="sectEject2">
            <ListItem v-for="item in sectList2" :key="item.name">
              <ListItemMeta :avatar="item.avatar" :title="item.name" :description="item.desci" />
              入门需求:{{item.keepName}} * {{item.keepNum}}
              <template #action>
                <li>
                  <Icon type="ios-star-outline" style=" font-family:Ionicons"/> 宗门人数 {{ item.playerNum }}
                </li>
                <li>
                  <Icon type="ios-thumbs-up-outline" style=" font-family:Ionicons"/> 宗门声望 {{ item.reputation }}
                </li>
                <li>
                  <Icon type="ios-chatbubbles-outline" style=" font-family:Ionicons"/> 宗门实力 {{ item.capacity }}
                </li>
                <li>
                  <Button style="margin-left: 10px;font-size: 12px;background-color: #00adff;color: #ffffff" type="circle" size="small" @click="JoinTheSect(item)">
                    入门
                  </Button>
                </li>
              </template>
              <template #extra>
                <img :src="item.sectIcon"  style="width: 240px">
              </template>
            </ListItem>
          </List>

          <Tabs value="name1">
            <TabPane label="宗门信息" name="name1">
              <List item-layout="vertical" >
                <ListItem >
                  <ListItemMeta :avatar="sectList.avatar" :title="sectList.name" :description="sectList.desci" />
                  宗门详情
                  <template #action>
                    <li>
                      <Icon type="ios-star-outline" /> 宗门人数 {{ sectList.playerNum }}
                    </li>
                    <li>
                      <Icon type="ios-thumbs-up-outline" /> 宗门声望 {{ sectList.reputation }}
                    </li>
                    <li>
                      <Icon type="ios-chatbubbles-outline" /> 宗门实力 {{ sectList.capacity }}
                    </li>
                    <Button style="margin-left: 10px;font-size: 12px;background-color: #00adff;color: #ffffff" type="circle" size="small"  @click.prevent="exitSectEject = true" >
                      退出宗门
                    </Button>
                  </template>
                </ListItem>
              </List>
              <p>当前宗门加成 声望已积累 {{ sectList.reputation  }} </p>
              <Steps v-for="(item, index) in sectList.sectBuffList" :key="index" :current="sectList.reputation"  direction="vertical">
                <Step  :title="item.honorValue.toString()" :content="item.sectDesc" ></Step>
              </Steps>
            </TabPane>
            <TabPane label="宗门弟子" name="name2">
              <Input v-model="inputContent" placeholder="请输入弟子名称..." style="margin-left:20px;width: auto" clearable/>
              <Button type="primary" @click="search" >查询</Button>
              <Button type="error" style="float: right;margin-right: 5px" @click.prevent="sectRegistCompe" >报名</Button>
              <Button type="warning" style="float: right;margin-right: 5px" @click.prevent="disiplePromotion" >晋升</Button>
              <Table v-model="sectEject3" stripe :columns="columns" :data="discipleTempData" style="margin-top: 5px">
                <template #name="{ row }">
                  <strong>{{ row.name }}</strong>
                </template>
                <template #action="{ row, index }">
                  <Button type="primary" size="small" style="margin-right: 5px" @click="duel(index)">切磋</Button>
                </template>
              </Table>
              <Page :total="discipleTotal" :current="discipleCurrentPage" :page-size='disciplePageSize' @on-change="changePage" show-total style="display: flex;justify-content: flex-end;margin-top:20px"></Page>
            </TabPane>

            <TabPane label="宗门宝库" name="name3" >
              每人每天可捐献10件,通过背包中的捐献按钮进行（绝品，灵宝可入库） 凌晨05:00 刷新捐献次数<br>
              兑换其他宗门法器时,需要对应的宗门信物 中品：1个,上品：2个,极品：3个。<br>
              <!--                <Button  @click.prevent="addEquit" style="margin: 10px;" size="small" type="info" ghost>-->
              <!--                  灵器入库-->
              <!--                </Button>-->
              <Select v-model="gameSectItemBo.sectId" clearable style="width:200px;margin: 4px">
                <Option v-for="item in sectItemList2" :value="item.id" :key="item.id" >{{ item.name }}</Option>
              </Select>
              <Input v-model="gameSectItemBo.name"  placeholder="法器名" clearable style="margin: 4px;width: auto" />
              <Input v-model="gameSectItemBo.level"  type="number" placeholder="法器等级" clearable style="margin: 4px;width: auto" />
              <Button type="primary" long @click="sectknapsack()" style="margin: 10px">查询</Button>
              <br>
              <Table border :columns="columns3" :data="sectknapsackList">
                <template #name="{ row }">
                  <strong>{{ row.name }}</strong>
                </template>
                <template #action="{ row, index }">
                  <Button type="primary" size="small" style="margin-right: 5px" @click="show2(index)">观察</Button>
                  <Button type="success" size="small"  @click="duihuantip(index)">兑换</Button>
                </template>
              </Table>
              <Page :total="total" :page-size="gameSectItemBo.pageSize" @on-change="changepage" @on-page-size-change="changepage2" show-sizer></Page>
              <!--                <Poptip trigger="hover" v-for="item in sectknapsackList" :key="item.id" :title="item.name" @on-popper-show="openEquipment(item)" @on-popper-hide="Equipment = null">-->


              <!--                </Poptip>-->
            </TabPane>
            <TabPane label="宗门藏宝阁" name="name13" >
              注意事项：藏宝阁兑换心法后,官网需要进入百宝袋背包进行心法修炼。
              <Table border :columns="columns4" :data="sectBaoGeList">
                <template #name="{ row }">
                  <strong>{{ row.name }}</strong>
                </template>
                <template #action="{ row, index }">
                  <!--                    <Button type="primary" size="small" style="margin-right: 5px" @click="show2(index)">观察</Button>-->
                  <Button type="success" size="small"  @click="synthesisItem(index)"  >兑换</Button>
                </template>
              </Table>
            </TabPane>
            <!--               <TabPane v-for="(item,index) in sectXinfaList" :key="index"  label="宗门心法" :name="index">
                              &lt;!&ndash; 内容 &ndash;&gt;
                             <Table  stripe :columns="conlumns4" :data="item">
                               <template #name="{ row }">
                                 <strong>{{ row.name }}</strong>
                               </template>
                               <template #action="{ row, index }">
                                 <Button v-if="row.learn==1 && row.id !=null" type="primary" size="small" style="margin-right: 5px" @click="xiulian(index)">停止修炼</Button>
                                 <Button v-if="row.learn!=1 && row.id !=null " type="primary" size="small" style="margin-right: 5px" @click="xiulian2(index)">开始修炼</Button>
                                 <Button v-if="row.learn!=1 && row.id !=null " type="error" size="small"  style="margin-right: 5px" @click="xiulian3(index)">遗忘</Button>
                                 &lt;!&ndash;                    <Button type="error" size="small" @click="remove(index)">Delete</Button>&ndash;&gt;
                               </template>
                             </Table>
                           </TabPane>-->
            <TabPane :label="sectXinfaName" name="name5">
              注意事项：如果开始修炼心法 地图上无法获取经验,但战斗成功会增加心法熟练度。 心法必须上一重掌握才能开始修炼下一重。
              <Table  stripe :columns="conlumns4" :data="sectXinfaList">
                <template #name="{ row }">
                  <strong>{{ row.name }}</strong>
                </template>
                <template #action="{ row, index }">
                  <Button v-if="row.learn==1 && row.id !=null" type="primary" size="small" style="margin-right: 5px" @click="xiulian(index,1)">停止修炼</Button>
                  <Button v-if="row.learn!=1 && row.grasp!=1 && row.id !=null " type="primary" size="small" style="margin-right: 5px" @click="xiulian2(index,1)">开始修炼</Button>
                  <Button v-if="row.learn!=1 && row.grasp==1 && row.id !=null " type="error" size="small"  style="margin-right: 5px" @click="xiulian3(index,1)">遗忘</Button>
                  <!--                    <Button type="error" size="small" @click="remove(index)">Delete</Button>-->
                </template>
              </Table>
            </TabPane>
            <TabPane :label="sectXinfaName2" name="name6">
              注意事项：如果开始修炼心法 地图上无法获取经验,但战斗成功会增加心法熟练度。 心法必须上一重掌握才能开始修炼下一重。
              <Table  stripe :columns="conlumns4" :data="sectXinfaList2">
                <template #name="{ row }">
                  <strong>{{ row.name }}</strong>
                </template>
                <template #action="{ row, index }">
                  <Button v-if="row.learn==1 && row.id !=null" type="primary" size="small" style="margin-right: 5px" @click="xiulian(index,2)">停止修炼</Button>
                  <Button v-if="row.learn!=1 && row.grasp!=1 && row.id !=null " type="primary" size="small" style="margin-right: 5px" @click="xiulian2(index,2)">开始修炼</Button>
                  <Button v-if="row.learn!=1 && row.grasp==1 && row.id !=null " type="error" size="small"  style="margin-right: 5px" @click="xiulian3(index,2)">遗忘</Button>
                  <!--                    <Button type="error" size="small" @click="remove(index)">Delete</Button>-->
                </template>
              </Table>
            </TabPane>
            <TabPane v-if="sectXinfaName3!=null" :label="sectXinfaName3" name="name7">
              注意事项：如果开始修炼心法 地图上无法获取经验,但战斗成功会增加心法熟练度。 心法必须上一重掌握才能开始修炼下一重。
              <Table  stripe :columns="conlumns4" :data="sectXinfaList3">
                <template #name="{ row }">
                  <strong>{{ row.name }}</strong>
                </template>
                <template #action="{ row, index }">
                  <Button v-if="row.learn==1 && row.id !=null" type="primary" size="small" style="margin-right: 5px" @click="xiulian(index,3)">停止修炼</Button>
                  <Button v-if="row.learn!=1 && row.grasp!=1 && row.id !=null " type="primary" size="small" style="margin-right: 5px" @click="xiulian2(index,3)">开始修炼</Button>
                  <Button v-if="row.learn!=1 && row.grasp==1 && row.id !=null " type="error" size="small"  style="margin-right: 5px" @click="xiulian3(index,3)">遗忘</Button>
                  <!--                    <Button type="error" size="small" @click="remove(index)">Delete</Button>-->
                </template>
              </Table>
            </TabPane>
            <TabPane label="宗门留言板" name="name4">
              注意事项：留音石只展示最近七天的留言。以及宗门大比一周一次，每周一到周三报名，周四-周五（18:00开始，可以改各自一下装备和神通顺序） 决八强和四强席位 周六 决出首席-次席-三席-末席 。
              后续四大宗门前四席进行宗门乱斗.
              奖励暂定：十六强 35贡献点、小额灵石袋*3; 八强 50贡献点,千机紫灵液,神秘物品 四强奖励待定。
              注意：发放奖励后清空报名情况及名次，名次会加入到宗门之后。持续一周
              <Button  @click.prevent="addBoard" style="margin: 10px" size="small" type="info" ghost>
                留音石
              </Button>
              <Table v-model="sectEject3" stripe :columns="columns2" :data="sectBoardList">
                <template #name="{ row }">
                  <strong>{{ row.name }}</strong>
                </template>
                <template #action="{ row, index }">
                  <Button type="primary" size="small" style="margin-right: 5px" @click="show(index)">点化</Button>
                  <!--                    <Button type="error" size="small" @click="remove(index)">Delete</Button>-->
                </template>
              </Table>
            </TabPane>
          </Tabs>
          <!--            <div  >-->
          <!--              <tr style="font-size: 15px;border-spacing: 10px;height: 30px;font-weight: bold">-->
          <!--                <td style="width: 35%;text-align: center"> 宗门名称</td>-->
          <!--                <td style="width: 15%;text-align: center"> 宗门人数</td>-->
          <!--                <td style="width: 15%;text-align: center"> 宗门声望</td>-->
          <!--                <td style="width: 15%;text-align: center"> 宗门实力</td>-->
          <!--                <td style="width: 25%;text-align: center"> 操作</td>-->
          <!--              </tr>-->
          <!--              <tr v-for="(item, idx) in sectList2" :key="idx" style="margin-bottom: 5px;">-->
          <!--                <td style="text-align: center"> {{ item.name }}</td>-->
          <!--                <td style="color: red;text-align: center"> {{ item.playerNum }}</td>-->
          <!--                <td style="text-align: center">{{ item.reputation }}</td>-->
          <!--                <td style="color: rgb(232 0 255);text-align: center">{{ item.capacity }}</td>-->
          <!--                <Button style="margin-left: 10px;font-size: 12px;background-color: #00adff;color: #ffffff" type="circle" size="small" @click="JoinTheSect(item)">-->
          <!--                  入门-->
          <!--                </Button>-->
          <!--              </tr>-->
          <!--            </div>-->
          <!--  宗门界面   -->
          <!--            <Result type="success" :title="sectList[0].name" :desc="'宗门人数：'+sectList[0].playerNum" :extra="sectList[0].desci">-->
          <!--              <template #actions>操作建议，一般放置按钮组</template>-->
          <!--            </Result>-->

          <!--              <tr  style="font-size: 15px;border-spacing: 10px;height: 30px;font-weight: bold">-->
          <!--                <td style="width: 35%;text-align: center"> 宗门名称</td>-->
          <!--                <td style="width: 15%;text-align: center"> 宗门人数</td>-->
          <!--                <td style="width: 15%;text-align: center"> 宗门声望</td>-->
          <!--                <td style="width: 15%;text-align: center"> 宗门实力</td>-->
          <!--                <td style="width: 25%;text-align: center"> 操作</td>-->
          <!--              </tr>-->
          <!--              <tr v-for="(item, idx) in sectList.sectDiscipleVoList" :key="idx" style="margin-bottom: 5px;">-->
          <!--                <td style="text-align: center"> {{ item.name }}</td>-->
          <!--                <td style="color: red;text-align: center"> {{ item.playerNum }}</td>-->
          <!--                <td style="text-align: center">{{ item.reputation }}</td>-->
          <!--                <td style="color: rgb(232 0 255);text-align: center">{{ item.capacity }}</td>-->
          <!--                <Button style="margin-left: 10px;font-size: 12px;background-color: #00adff;color: #ffffff" type="circle" size="small" @click="JoinTheSect(item)">-->
          <!--                  点化-->
          <!--                </Button>-->
          <!--              </tr>-->
        </Modal>
        <!-- 锻造 -->
        <Modal width="824" style="font-family: STXinWei;"  title="锻造" v-model="forgeEject" :styles="{ top: '100px' }" class="organizeEject">
          <Tabs value="name34">
            <TabPane label="图纸" name="name34">
              <Table border :columns="columnsTuz" :data="tuzhiList">
                <template #name="{ row }">
                  <strong>{{ row.name }}</strong>
                </template>
                <template #action="{ row, index }">
                  <Button type="primary" size="small" style="margin-right: 5px" @click="show3(index)">图纸</Button>
                  <!--                    <Button type="success" size="small"  @click="duanzao(index)">锻造</Button>-->
                </template>
              </Table>
            </TabPane>
            <TabPane label="委托锻造" name="name2">
              <Table border :columns="columnsTuzing" :data="tuzhiingList1">
                <template #name="{ row }">
                  <strong>{{ row.name }}</strong>
                </template>
                <template #action="{ row, index }">
                  <Button type="primary" size="small" style="margin-right: 5px" v-if="row.receive==0" @click="show4(index)">领取</Button>
                  <!--                    <Button type="success" size="small" v-if="row.isMet!=null && row.isMet"  @click="duanzao(index)">锻造</Button>-->
                </template>
              </Table>
            </TabPane>
            <TabPane label="历史锻造记录" name="name3">
              <Table border :columns="columnsTuzing" :data="tuzhiingList2">
                <template #name="{ row }">
                  <strong>{{ row.name }}</strong>
                </template>
                <template #action="{ row, index }">
                  <!--                    <Button type="primary" size="small" style="margin-right: 5px" v-if="row.receive==0" @click="show4(index)">领取</Button>-->
                  <!--                    <Button type="success" size="small" v-if="row.isMet!=null && row.isMet"  @click="duanzao(index)">锻造</Button>-->
                </template>
              </Table>
            </TabPane>
          </Tabs>
        </Modal>
        <!-- 队伍名字弹出框 -->
        <Modal width="320" style="font-family: STXinWei;"  title="队伍名字" v-model="armyEject" @on-ok="changeEstablish()" :styles="{ top: '100px' }">
          <div class="pasEject" style="height: 50px">
            <Input v-model="armyName" placeholder="请输入队伍名字" />
          </div>
          <div class="pasEject" >
            <Input v-model="armyLevel" placeholder="请输入队伍最低等级" />
          </div>
          <div class="pasEject" >
            <Select v-model="armyType" style="width:200px;margin: 10px 0">
              <Option v-for="item in armyTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </div>

        </Modal>

        <!-- 队伍列表弹出框 -->
        <Modal width="720" style="font-family: STXinWei;"  title="队伍列表" v-model="armyListEject" :styles="{ top: '100px' }">
          <!--              v-model="sectEject3"-->
          <Table  stripe :columns="zcolumns2" :data="armyList">
            <template #name="{ row }">
              <strong>{{ row.name }}</strong>
            </template>
            <template #action="{ row, index }">
              <Button type="primary" size="small" style="margin-right: 5px" @click="JoinTheTeam(row)">加入队伍</Button>
              <!--                    <Button type="error" size="small" @click="remove(index)">Delete</Button>-->
            </template>
          </Table>
          <!--                <tr  style="font-size: 15px;border-spacing: 10px;height: 30px;font-weight: bold">
                            <td style="height: 30%;text-align: center"> 队伍名</td>
                            <td style="height: 30%;text-align: center"> 队伍类型</td>
                            <td style="height: 15%;text-align: center"> 加入等级</td>
                            <td style="height: 15%;text-align: center"> 队长</td>
                            <td style="height: 15%;text-align: center"> 剩余位置</td>
                            <td style="height: 25%;text-align: center"> 操作</td>
                          </tr>
                          <tr v-for="(item, idx) in armyList" :key="idx" style="margin-bottom: 5px;">
                              <td style="text-align: center"> {{ item.armyName }}</td>
                              <td style="color: red;text-align: center"> {{ item.armyLevel }}</td>
                              <td style="text-align: center">{{ item.captainName }}</td>
                              <td style="color: rgb(232 0 255);text-align: center">{{ item.armyNum }}</td>
                              <Button style="margin-left: 20px;font-size: 12px;background-color: #00adff;color: #ffffff" type="circle" size="small" @click="JoinTheTeam(item)">
                                  加入队伍
                              </Button>
                          </tr>-->
        </Modal>
        <Modal width="820"  title="切磋过程" v-model="duelEject" :styles="{ top: '100px' }">
          <div>
            <!-- 统计伤害   -->
            <div v-if="battleTotal" >
              演武场特殊效果：生命提升 200%
              战斗统计：
              <Table  ref="table"  size="small" :columns="columnsBattle" :data="battleTotalList"></Table>
            </div>
            <div class="monster" :class="[monsterList.length == 1 ? 'monstercenter' : '']">
              <Poptip trigger="hover" v-for="item in monsterList" :key="item.id" :title="item.name">
                敌人：{{ item.name }}
                <br>
                <Progress :percent="(Math.max(item.health, 0) / item.maxLife) * 100" stroke-color="#FF69B4" style="width: 250px">
                  <span>{{ item.health }}</span>
                </Progress>
                <div slot="content">
                  <p>生命值 {{ item.health }}</p>
                  <p>物攻 {{ item.physicalAttack }}</p>
                  <p>法攻 {{ item.magicAttack }}</p>
                  <p>物理防御力 {{ item.defence }}</p>
                  <p>法术防御力 {{ item.magicDefense }}</p>
                  <p>命中率 {{ item.hitRate * 100 }}%</p>
                  <p>闪避率 {{ item.evade * 100 }}%</p>
                  <p>暴击率 {{ item.criticalHitValue * 100 }}%</p>
                  <p>暴击伤害 {{ item.critDamage * 100 }}%</p>
                  <p>行动速度 {{ item.movingSpeed }}</p>
                </div>
              </Poptip>
            </div>
            <div class="monster" :class="[gameCharacterVO.length == 1 ? 'monstercenter' : '']" v-if="this.teamStatus != 1">
              <Poptip trigger="hover" v-for="(item,idx) in gameCharacterVO" :key="idx" :title="item.name">
                {{ idx == 0 ? "角色: " : "真灵: " }}{{ item.name || "" }}
                <br>
                <Progress :percent="(Math.max(item.health || auraLife, 0) / item.formerHealth) * 100" style="width: 250px">
                  <span>{{ item.health || auraLife }}</span>
                </Progress>
                <div slot="content">
                  <p>生命值 {{ item.health }}</p>
                  <p>物攻 {{ item.physicalAttack }}</p>
                  <p>法攻 {{ item.magicAttack }}</p>
                  <p>物理防御力 {{ item.defense }}</p>
                  <p>法术防御力 {{ item.magicDefense }}</p>
                  <p>命中率 {{ item.hitRate * 100 }}%</p>
                  <p>闪避率 {{ item.evade * 100  || 0}}%</p>
                  <p>暴击率 {{ (item.criticalHitValue * 100).toFixed(2)  || 0}}%</p>
                  <p>暴击伤害 {{ (item.critDamage * 100).toFixed(2) || 0 }}%</p>
                  <p>行动速度 {{ item.movingSpeed }}</p>
                </div>
              </Poptip>
            </div>
            <div class="recording" id="recording">
              <h2 style="margin-top: 20px" v-if="monsterList.length <= 0">暂无记录</h2>
              <battle-process v-bind:recordings="recording"></battle-process>
            </div>
          </div>
        </Modal>
        <!-- 设置 -->
        <Modal width="750" title="设置" v-model="setEject" @on-ok="changeSet()" :styles="{ top: '100px' }">
          <Form ref="formInline" :model="gamePackageBo" :label-width="80" inline>
            <FormItem label="自动出售">
              <i-switch v-model="gamePackageBo.isOpen" :true-value="1" :false-value="0" />
            </FormItem>
            <FormItem label="最低等级">
              <Input type="text" v-model="gamePackageBo.minLevel"></Input>
            </FormItem>
            <FormItem label="最高等级">
              <Input type="text" v-model="gamePackageBo.maxLevel"></Input>
            </FormItem>
            <FormItem label="品质列表">
              <CheckboxGroup v-model="gamePackageBo.quality">
                <Checkbox label="1">破损</Checkbox>
                <Checkbox label="2">普通</Checkbox>
                <Checkbox label="3">良品</Checkbox>
                <Checkbox label="4">上品</Checkbox>
                <Checkbox label="5">绝品</Checkbox>
                <Checkbox label="6">灵宝</Checkbox>
              </CheckboxGroup>
            </FormItem>
          </Form>
        </Modal>

        <!-- 攻略弹出框 -->
        <Modal width="620" title="更新日志" v-model="strategy" @on-ok="this.strategy = false" :styles="{ top: '40px' }">
          <updateLog></updateLog>
        </Modal>
        <!-- 频道弹出框 -->
        <Modal width="850" title="频道" v-model="pindao" @on-ok="this.strategy = false" :styles="{ top: '40px' }">
          <Im ></Im>
        </Modal>
        <!-- 选择角色弹出框 -->
        <Modal width="620" title="切换角色" v-model="selectChara" @on-ok="this.selectChara = false" :styles="{ top: '40px' }">
          <selectChara></selectChara>
        </Modal>

        <Modal v-model="duihuanEject" title="兑换" @on-ok="duihuan">
          <p>确定兑换该法器吗</p>
        </Modal>

        <!-- 修改密码弹出框 -->
        <Modal width="620" title="修改密码" v-model="pasEject" @on-ok="confirmPassword()" :styles="{ top: '100px' }">
          <div class="pasEject">
            <Input v-model="originalPas" placeholder="请输入原密码" />
            <Input v-model="newPas" placeholder="请输入新密码" />
            <Input v-model="confirmPas" placeholder="确认密码" />
          </div>
        </Modal>

        <!-- 兑换码 -->
        <Modal width="620" title="兑换码" v-model="exchangeEject" @on-ok="changeExchange()" :styles="{ top: '100px' }">
          <Input v-model="exchange" placeholder="请输入兑换码" />
        </Modal>

        <!-- 新增留言 -->
        <Modal width="620" title="留音石" v-model="boardEject" @on-ok="changeBoard()" :styles="{ top: '100px' }">
          留言内容：
          <Input v-model="boardMsg"  placeholder="10贡献点留言一次"></Input>
        </Modal>

        <!-- 排行榜 -->
        <Modal style="font-family: STXinWei" width="720" title="排行榜" v-model="PlanEject" :styles="{ top: '100px' }">
          <rankingList></rankingList>
        </Modal>

        <!-- 在线玩家 -->
        <Modal style="font-family: STXinWei" footer-hide="true" width="1020" title="任务榜单" v-model="RackingEject" :styles="{ top: '100px' }" >
          <playersList></playersList>
        </Modal>

        <!-- 黑市 -->
        <Modal style="font-family: STXinWei" width="920" title="黑市" v-model="tradingBankEject" :styles="{ top: '100px' }">
          <tradingBank ref="tradingBank"></tradingBank>
        </Modal>

        <!-- 锁妖塔 -->
        <Modal style="font-family: STXinWei" width="920" title="秘境" v-model="lockDemonTowerEject" :draggable="true" :mask-closable="false" :styles="{ top: '100px' }">
          <lockDemonTower ref="lockDemonTower"></lockDemonTower>
        </Modal>

    </div>

</template>

<script>
import playersList from "./playersList.vue";
import rankingList from "./rankingList.vue";
import updateLog from "./updateLog.vue";
import selectChara from "./selectChara.vue";
import tradingBank from "./tradingBank.vue";
import lockDemonTower from "./lockDemonTower.vue";
import { Vue } from 'vue';
import Im from "./Im";
import banner1 from "../assets/back1.jpg";
import qs from "query-string";
import { sleep } from "../utils";
import battleProcess from "./battleProcess";

export default {
    name: "headers",
    data() {
        return {
          discipleTableData: [],  //表格源数据
          discipleTempData: [],   //表格显示数据
          discipleCurrentPage: 1,  //当前页
          discipleTotal: 0,   //数据总数
          limFlag:false,
          disciplePageSize: 15,   //一页展示的条数  默认一页展示10条，有很多数据就可以写其他的数
          inputContent: '',  //搜索的数据值
          columnsBattle: [
              {
                title: '名称',
                key: 'name',
                fixed: 'left',
                width: 200,
              },
              {
                title: '治疗',
                key: 'zhiliao',
                width: 100,
                sortable: true
              },
              {
                title: '回蓝',
                key: 'huilan',
                width: 100,
                sortable: true
              },
              {
                title: '伤害',
                key: 'damage',
                width: 100,
                sortable: true
              },
              {
                title: '普攻',
                key: 'attack',
                width: 100,
                sortable: true
              },
              {
                title: '力道',
                key: 'lidao',
                width: 100,
                sortable: true
              },
              {
                title: '灵力',
                key: 'lingli',
                width: 100,
                sortable: true
              },
              {
                title: '持续',
                key: 'sustained',
                width: 100,
                sortable: true
              },
              {
                title: '反击',
                key: 'counterattack',
                width: 100,
                sortable: true
              },
              {
                title: '被控制',
                key: 'control',
                width: 100,
                sortable: true
              }
            ],
            columns: [
              {
                title: '弟子名称',
                key: 'discipleName'
              },
              {
                title: '弟子境界',
                key: 'discipleRealm'
              },
              {
                title: '弟子贡献值',
                key: 'contribution'
              },
              {
                title: '弟子职位',
                key: 'postion'
              },
              {
                title: '所在地图',
                key: 'mapName'
              },
              {
                title: '大比名次',
                key: 'compeRank'
              },
              {
                title: '操作',
                slot: 'action',
                width: 150,
                align: 'center'
              }
            ],
            columnsTuz: [
              {
                title: '图纸名称',
                key: 'itemName'
              },
              {
                title: '图纸等级',
                key: 'level'
              },
              {
                title: '图纸数量',
                key: 'itemNum'
              },
              {
                title: '操作',
                slot: 'action',
                width: 150,
                align: 'center'
              }
            ],
            columnsTuzing: [
              {
                title: '图纸名称',
                key: 'name',
                width: 200
              },
              {
                title: '锻造过程',
                key: 'result'
              },
              {
                title: '锻造完成时间',
                key: 'linTime'
              },
              {
                title: '成功率',
                key: 'rate',
                render: (h, params) => {
                  let w= params.row.rate;
                  if(params.row.rate!=null){
                    w=(params.row.rate*100).toFixed(2)+"%";
                  }
                  return h('span', w);
                }
              },
              {
                title: '是否领取',
                key: 'receive',
                render: (h, params) => {
                  switch (params.row.receive) {
                    case 0:
                      return h('span', '未领取');
                      break;
                    case 1:
                      return h('span', '已领取');
                      break;
                  }
                },
              },
              {
                title: '操作',
                slot: 'action',
                width: 150,
                align: 'center'
              }
            ],
            columns2: [
              {
                title: '留言人',
                key: 'name'
              },
              {
                title: '留言内容',
                key: 'content'
              },
               {
                 title: '操作',
                 slot: 'action',
                 width: 150,
                 align: 'center'
               }
            ],
            zcolumns2: [
              {
                title: '队伍名',
                key: 'armyName'
              },
              {
                title: '队伍类型',
                key: 'armyType',
                render: (h, params) => {
                  switch (params.row.armyType) {
                    case 1:
                      return h('span', '普通');
                      break;
                    case 2:
                      return h('span', '挑战');
                      break;
                  }
                },
              },
              {
                title: '加入等级',
                key: 'armyLevel'
              },
              {
                title: '队长',
                key: 'captainName'
              },
              {
                title: '剩余位置',
                key: 'armyNum'
              },
              {
                title: '操作',
                slot: 'action',
                width: 120,
                align: 'center'
              }
            ],
            conlumns4:[
              {
                title: '心法名',
                width: 220,
                key: 'xinfaName'
              },
              {
                title: '描述',
                key: 'xinfaDesc',
                width: 160,
              tooltip:true
              },
              {
                title: '类别',
                key: 'xinfaTypeDesc',
                // render: (h, params) => {
                //   switch (params.row.xinfaType) {
                //     case 1:
                //       return h('span', '青元诀');
                //       break;
                //     case 2:
                //       return h('span', '化脉诀');
                //       break;
                //     default:
                //       return h('span', '基础剑法');
                //       break;
                //   }
                // }
              },
              {
                title: '熟练度',
                key: 'masteryNeed',
                render: (h, params) => {
                  if(params.row.mastery==null){
                    params.row.mastery=0;
                    params.row.masteryNeed=0;
                  }
                  return h('span', params.row.mastery+'/'+params.row.masteryNeed);
                }
              },
              {
                title: '完成度',
                key: 'grasp',
                render: (h, params) => {
                  switch (params.row.grasp) {
                    case 1:
                      return h('span', '掌握');
                      break;
                    default:
                      return h('span', '未掌握');
                      break;
                  }
                }
              },
              {
                title: '是否修炼',
                key: 'learn',
                render: (h, params) => {
                  switch (params.row.learn) {
                    case 1:
                      return h('span',{style:'color:red'}, '是');
                      break;
                    default:
                      return h('span', '否');
                      break;
                  }
                }
              },
              {
                title: '操作',
                slot: 'action',
                width: 100,
                align: 'center'
              }
            ],
            columns3: [
              {
                title: '宝物',
                width: 210,
                resizable: true,
                key: 'itemName'
              },
              {
                title: '佩戴',
                key: 'kind',
                render: (h, params) => {
                  switch (params.row.kind) {
                    case 1:
                      return h('span', '武器');
                      break;
                    case 2:
                      return h('span', '玄端');
                      break;
                    case 3:
                      return h('span', '头冠');
                      break;
                    case 4:
                      return h('span', '项链');
                      break;
                    case 7:
                      return h('span', '戒指');
                      break;
                    case 9:
                      return h('span', '绶带');
                      break;
                    case 10:
                      return h('span', '鞜履');
                      break;
                  }
                }
              },
              {
                title: '灵素',
                key: 'weaponTypeDec',
              },
              {
                title: '等级',
                key: 'level',
                sortable: true
              },
              {
                title: '点数',
                key: 'contriPoint',
                sortable: true
              },
              {
                title: '品阶',
                key: 'scoreLevel'
              },
              {
                title: '操作',
                slot: 'action',
                width: 150,
                align: 'center'
              },
            ],
          columns4: [
            {
              title: '宝物',
              width: 210,
              resizable: true,
              key: 'syntheticName'
            },
            {
              title: '需要职位',
              key: 'syntheticPostion'
            },
            {
              title: '兑换次数',
              key: 'syntheticNum'
            },
            {
              title: '贡献点',
              key: 'syntheticMoney',
              sortable: true
            },
            {
              title: '材料',
              width: 200,
              key: 'syntheticExp',
              render: (h, params) => {
                let name="材料一:无";
                let name2="材料二:无";
                let name3="材料三:无";
                if(params.row.materOneName!=null){
                  name = "材料一:"+params.row.materOneName+" 需要 "+params.row.materOneNum+";";
                }
                if(params.row.materTwoName!=null){
                  name2 = "材料二:"+params.row.materTwoName+" 需要 "+params.row.materTwoNum+";";
                }
                if(params.row.materThreeName!=null){
                  name3 = "材料三:"+params.row.materThreeName+" 需要 "+params.row.materThreeNum+";";
                }
                return h('div', [
                  h('p', name),
                  h('p', name2),
                  h('p', name3)
                ]);
              }
            },
            {
              title: '操作',
              slot: 'action',
              width: 150,
              align: 'center'
            },
          ],
            monsterList: [],
            gameCharacterVO: [],
            gamePetVOList: [],
            recording: [],
            recordStatus: false, // 战斗记录的一个状态
            mapName: "", // 选择查看的地图名字
            battleTotal: false, // 战斗统计弹出框
            battleTotalList: [],//战斗统计列表
            battleObject: {
              name: "",
              damage: 0,
              attack: 0,
              lidao: 0,
              lingli: 0,
              zhiliao: 0,
              huilan: 0,
              sustained: 0,
              counterattack: 0,
              control: 0,
            },
            strategy: false, // 攻略弹出框
            pindao:false,
            selectChara: false,
            pasEject: false, // 修改密码弹出框
            exchangeEject: false, // 兑换码弹出框
            boardEject: false, // 留言弹出框
            PlanEject: false, // 排行榜弹出框
            RackingEject: false, // 在线玩家弹出框
            organizeEject: false, // 组队弹出框
            sectEject: false, // 宗门弹出框
            forgeEject: false,//锻造弹出框
            sectEject2: false, // 宗门列表
            itemEject2: false, // 宗门宝阁装备详情
            tzitemEject2: false, // 图纸所需详情
            duanzaoPackItemId: null,
            formulaVo: {},
            itemFucaiNum:[],
            gamFordrawingBo: {
              // 出售设置
              charaId: "",
              packItemIds: "",
              matList: [],
            },
            formulaBo: {
              itemId:null,
              haveNum:0
            },
            formulaMatZiList: [],
            tuzhiList: [],
            tuzhiingList: [],
            tuzhiingList1: [],
            tuzhiingList2: [],
            duihuanEject: false,
            indexDH:0,
            gameSectItemBo: {
              // 查询宝库设置
              charaId: "",
              sectId: null,
              level:null,
              page: 1,
              pageSize:15,
              name: null,
            },
            item:{},
            zhenitem:{},
            discipleId:'',
            donateEject: false, // 捐献提示框
            exitSectEject: false, // 退出提示框
            releaseEject: false, // 放生提示框
            checkboxList:[],//选择装备捐献
            packItemId:"",//捐献需要用到的 捐献选择的装备
            sectEject3: false, // 宗门列表
            armyEject: false, // 队伍名字的弹出框
            armyListEject: false, // 队伍列表弹出框
            duelEject: false, // 切磋记录弹出框
            setEject: false, // 设置自动出售
            originalPas: "", // 原密码
            newPas: "", // 新密码
            confirmPas: "", // 确认密码
            mapLootsList: undefined, // 地图掉落
            exchange: "", // 兑换码
            boardMsg: "", // 留言内容
            teamStatus: 0, // 组队状态 0 无队伍 1有队伍
            sectStatus: 0, // 宗门状态 0 无宗门 1有宗门
            armyName: "", //  队伍名字
            armyLevel: 0, //  队伍等级
            armyType: 1, //  队伍类型
            armyTypeList: [
              {
                value: '1',
                label: '普通'
              },
              {
                value: '2',
                label: '挑战'
              }
            ],
            armyList: [], // 队伍列表
            organizeList: [], // 组队列表
            sectList: [], // 宗门列表
            sectBuffs: {}, // 宗门加成列表
            sectBaoGeList:  [], // 宗门藏宝可
            sectList2: [], // 宗门列表
            sectXinfaName:null,
            sectXinfaName2:null,
            sectXinfaName3:null,
            sectXinfaList: [], // 宗门心法列表
            sectXinfaList2: [], // 宗门心法列表
            sectXinfaList3: [], // 宗门心法列表
            sectItemList2: [], // 选择宗门列表
            sectBoardList: [], // 宗门留言列表
            sectknapsackList: [], // 宗门宝库列表
            total: 0,
            //pageSize: 20,
            mapList: [], // 地图列表
            mapid: "", // 地图id
            combatRecordProcess: [], // 战斗记录过程
            gamePackageBo: {
                // 出售设置
                charaId: "",
                isOpen: 0,
                maxLevel: "",
                minLevel: "",
                quality: [],
            },
            PetsEject: false, // 真灵弹出框
            PetsList: [],
            Pets: null,
            isActive:false, // 切换主体
            electronicEquipment: false, // 电子设备
            tradingBankEject: false, // 黑市
            lockDemonTowerEject: false,//锁妖塔
            tradingBankList: []
        };
    },
    created() {
      const theme = window.localStorage.getItem("isTheme");
      if(theme === "black"){
        this.isActive=true;
      }else{
        this.isActive=false;
      }
      // 判断是手机端还是pc端
      if (this._isMobile()) {
        this.electronicEquipment = false;
      } else {
        this.electronicEquipment = true;
      }
    },
    updated() {
      // 战斗记录定位到底部
      const el = document.getElementById("recording");
      const max = el.scrollHeight - el.clientHeight;
      if (max - el.scrollTop < 80) {
        el.scrollTop = el.scrollHeight;
      }
    },
    components: { playersList, rankingList, updateLog,selectChara, tradingBank,Im, lockDemonTower,battleProcess },
    methods: {
        // 切换页码
        changePage (val) {
          this.discipleCurrentPage = val
          var _start = (val - 1) * this.disciplePageSize
          var _end = val * this.disciplePageSize
          this.discipleTempData = this.discipleTableData.slice(_start, _end)
        },
        // 搜索
        search () {
          this.discipleCurrentPage = 1
          this.getList();
        },
        // 搜索出来的数据做处理
        getList () {
          let search = this.inputContent
          let list = this.discipleTableData.filter(item => item.discipleName.includes(search)) // 查出来的数据
          this.discipleTotal = list.length
          let start = (this.discipleCurrentPage - 1) * this.disciplePageSize
          let end = this.discipleCurrentPage * this.disciplePageSize
          var temp = list.slice(start, end) // 截取之后的数据
          this.discipleTempData = temp
        },
        cs1() {
            this.$Notice.open({
                title: '还没有呢 别着急',
                desc: '淡炒稀饭(长老终结者)'
            });
        },
        // 返回品质颜色
        distinguishColor(color) {
            if (color == 1) {
                return "#000";
            } else if (color == 2) {
                return "#c5c52f";
            } else if (color == 3) {
                return "#049c04";
            } else if (color == 4) {
                return "#005aff";
            } else if (color == 5) {
                return "#ff00e0";
            } else if (color == 6) {
                return "#ff0000";
            } else {
                return "#ff00c3e0";
            }
        },
        show2 (index) {
          this.itemEject2=true;
          this.item=this.sectknapsackList[index]
        },
        duel(index){
          this.duelEject=true;
          this.discipleId=this.discipleTempData[index].id;
          //清空
          this.recording = [];
          this.monsterList = [];
          //this.gameCharacterVO = [];
          this.startTheBattle();
        },
        show3 (index) {
          this.duanzaoPackItemId=this.tuzhiList[index].packItemId;
          this.$http
            .post(
              "/gameCharaEquip/queryForgingOrPills?charaId=" +
              this.getCookie("charaId") +
              "&packItemIds=" + this.duanzaoPackItemId
            )
            .then((res) => {
              this.formulaVo=res.data.data;
              //满足条件展示
              if(this.formulaVo.isMeet){
                this.tuzhiList[index].isMet=true;
              }
              this.formulaMatZiList = [];
              this.itemFucaiNum = [];
              this.tzitemEject2=true;
            })
            .catch((err) => {
              this.$Notice.warning({title:res.data.msg});
            });
        },
        show4 (index) {
          let id=this.tuzhiingList1[index].id;
          this.$http
            .post(
              "/gameCharaEquip/receiveForgingPlayer?charaId=" +
              this.getCookie("charaId") +
              "&forPlayerId=" + id
            )
            .then((res) => {
              this.$Notice.warning({title:res.data.msg});
              this.commForging();
              this.refreshPackage();
            })
            .catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
        },
        //yuan
        getmatList(itemId,index){
          var falg=false;
          if(this.formulaMatZiList.length > 0){
            for (var i = 0; i < this.formulaMatZiList.length; i++) {
                  if(this.formulaMatZiList[i].itemId == itemId){
                    this.formulaMatZiList[i].haveNum=this.itemFucaiNum[index];
                    falg=true;
                    break;
                  }
            }
          }
          if(!falg){
            this.formulaBo = {};
            this.formulaBo.itemId=itemId
            this.formulaBo.haveNum=this.itemFucaiNum[index];
            this.formulaMatZiList.push(this.formulaBo);
          }
        },
        //委托锻造
        commForging(){
          this.$http
            .post(
              "/gameCharaEquip/queryForgingPlayer?charaId=" +
              this.getCookie("charaId")
            )
            .then((res) => {
              this.tuzhiingList=res.data.data;
              this.tuzhiingList1 = [];
              this.tuzhiingList2 = [];
              for (let i = 0; i < this.tuzhiingList.length; i++) {
                if(this.tuzhiingList[i].receive == 0 ){
                  this.tuzhiingList1.push(this.tuzhiingList[i]);
                }else{
                  this.tuzhiingList2.push(this.tuzhiingList[i]);
                }
              }
            })
            .catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
        },
        duanzao(){
          //let packItemId=this.tuzhiList[index].packItemId;
          this.$http
            .post(
              "/gameCharaEquip/forgingEquipmentOrPills",{
          ...this.gamFordrawingBo,
              charaId: this.getCookie("charaId"),
              packItemIds:  this.duanzaoPackItemId,
              matList: this.formulaMatZiList,
          })
            .then((res) => {
              this.tzitemEject2 = false;
              this.$Notice.success({title:res.data.msg});
              this.commForging();
              this.refreshMaterialPackage();
            })
            .catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
        },
        // 灵宠状态
        PetsStatus(val) {
            if (val == 0) {
                return "休息";
            } else {
                return "出战";
            }
        },
        // 品级 普通-稀有-灵级-王级-域级-圣级-神级
        PetsGrade(val) {
            if (val == 1) {
                return "普通";
            } else if (val == 2) {
                return "稀有";
            } else if (val == 3) {
                return "灵级";
            }  else if (val == 4)  {
              return "王级";
            } else  if (val == 5) {
              return "域级";
            } else  if (val == 6) {
              return "圣级";
            } else {
              return "神级";
            }
        },
        // 元素状态
        petsEl(val) {
            if (val == 1) {
                return "金";
            } else if (val == 2) {
                return "木";
            } else if (val == 3) {
                return "水";
            } else if (val == 4) {
                return "火";
            } else if (val == 5) {
                return "土";
            } else if (val == 6) {
                return "风";
            } else if (val == 7) {
                return "雷";
            } else if (val == 8) {
              return "冰";
            } else {
                return "无";
            }
        },
        // 类型
        petsType(val) {
            if (val == 1) {
                return "五行系";
            } else if (val == 2) {
                return "风雷系";
            } else if (val == 3) {
                return "防御型";
            } else {
                return "无";
            }
        },
        realmColorF() {
            var roundColor = Math.round(Math.random() * 5);
            if (roundColor == 1) {
                return "red";
            } else if (roundColor == 2) {
                return "skyblue";
            } else if (roundColor == 3) {
                return "#2700ff";
            } else if (roundColor == 4) {
                return "#d800ff";
            } else if (roundColor == 5) {
                return "#06c11d";
            }
        },

        // 获取组队地图列表
        TeamMapList() {
            this.$http.get("/gameAmry/queryMapList").then((res) => {
                this.mapList = res.data.data;
            });
        },

        // 查看战斗记录
        CombatRecord() {
            if (!this.mapName) {
                this.$Notice.warning({title:"提示",desc:"请在上方选择一个地图"});
                return;
            }
            for (var i = 0; i < this.mapList.length; i++) {
                if (this.mapName == this.mapList[i].mapName) {
                    this.mapid = this.mapList[i].mapId;
                }
            }
            this.$http
                .post(
                    "/gameAmry/getAmryRecord?charaNo=" +
                    this.$store.state.user.accountId +
                    "&mapId=" +
                    this.mapid
                )
                .then((res) => {
                    this.combatRecordProcess = res.data.data;

                    for (let i = 0; i < this.combatRecordProcess.length; i++) {
                        if (this.combatRecordProcess[i].gameItemsList != null) {
                            this.combatRecordProcess[
                                i
                            ].gameItemsList1 = this.combatRecordProcess[i].gameItemsList.map(
                                (val) => {
                                    return val.itemName;
                                }
                            );
                        }
                    }

                    this.recordStatus = true;
                    setTimeout(() => {
                        this.recordStatus = false;
                    }, 10000);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // 打开组队
        openOrganize() {
            this.organizeEject = true;
            this.armyBoundary();
        },
        //打开兑换提示
        duihuantip(index){
          this.indexDH=index;
          this.duihuanEject=true;
        },
        //打开修炼提示
        xiulian2(index,listNum){
          if(listNum === 1){
            this.item=this.sectXinfaList[index];
          }else if(listNum === 2){
            this.item=this.sectXinfaList2[index];
          }else if(listNum === 3){
            this.item=this.sectXinfaList3[index];
          }
          this.xiulianxinfa(1);
        },
        xiulian3(index,listNum){
          if(listNum === 1){
            this.item=this.sectXinfaList[index];
          }else if(listNum === 2){
            this.item=this.sectXinfaList2[index];
          }else if(listNum === 3){
            this.item=this.sectXinfaList3[index];
          }
          //this.item=this.sectXinfaList[index];
          this.yiwangxinfa();
        },
        xiulian(index,listNum){
          if(listNum === 1){
            this.item=this.sectXinfaList[index];
          }else if(listNum === 2){
            this.item=this.sectXinfaList2[index];
          }else if(listNum === 3){
            this.item=this.sectXinfaList3[index];
          }
          //this.item=this.sectXinfaList[index];
          this.xiulianxinfa(0);
        },
        xiulianxinfa(status){
          this.$http
            .post(
              "/gameSect/updateDisXinfa?charaId=" +
              this.getCookie("charaId") +
              "&xinfaId=" +
              this.item.id +
            "&status=" +
              status
            )
            .then((res) => {
              this.$Notice.success({title:res.data.msg});
              //心法列表
              this.querySectXinfaList();
            })
            .catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
        },
        yiwangxinfa(){
          this.$http
            .post(
              "/gameSect/removeDisXinfa?charaId=" +
              this.getCookie("charaId") +
              "&xinfaId=" +
              this.item.id
            )
            .then((res) => {
              this.$Notice.success({title:res.data.msg});
              //心法列表
              this.querySectXinfaList();
            })
            .catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
        },
        //兑换
        duihuan(){
          this.item=this.sectknapsackList[this.indexDH]
          this.$http
            .post(
              "/gameSect/playersExchangeWarehouse?charaId=" +
              this.getCookie("charaId") +
              "&wareId=" +
              this.item.packItemId
            )
            .then((res) => {
              this.sectknapsackList.splice(this.indexDH, 1);
              this.$Notice.success({title:res.data.msg});
              this.refreshPackage(); // 获取全部包裹
              this.duihuanEject=false;
            })
            .catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
        },
        // 进入队伍界面
        armyBoundary() {
            this.$http
                .post("/gameAmry/armyBoundary/?charaId=" + this.getCookie("charaId"))
                .then((res) => {
                    if (res.data.msg == "无队伍") {
                        this.teamStatus = 0;
                        this.organizeList = {};
                        this.organizeList.charaInfoVoList = [{}, {}, {}];
                        this.$bus.$emit("teamStatusMsg1", "无队伍了");
                    } else {
                        this.teamStatus = 1;
                        this.organizeList = res.data.data;
                        this.TeamMapList(); // 获取组队地图列表
                        this.$bus.$emit("teamStatusMsg", "有队伍了");
                    }
                })
                .catch((err) => {
                    console.log(err, "进入队伍界面");
                });
        },

        // 打开宗门
        openSect() {
          this.sectEject = true;
          this.sectBoundary();

          /*//留言板
          this.sectBorad();
          //宝库列表
          this.sectknapsack(1);
          //加成列表
          this.sectBuff();*/

        },
        // 打开锻造页面
        openforge() {
          this.forgeEject = true;
          this.tuzhiList = this.$store.state.tuzhiList;
          //查询委托锻造列表
          this.commForging();
        },
        changepage(index) {
          this.sectknapsack(index);
        },
        changepage2(index) {
          this.gameSectItemBo.pageSize=index;
          this.sectknapsack(1);
        },
        //灵气入库
        addEquit(){
          this.donateEject = true;
          this.checkboxList=[];
          //获取列表
          this.$http
            .post("gameChara/getCharaPackage?charaId=" + this.getCookie("charaId"))
            .then((res) => {
              res.data.data.forEach((item, idx) => {
                if (item.color == 6 && item.enhanLevel==0 && item.scoreLevel != null) {
                  this.checkboxList.push(item);灵力
                }
              });
            })
            .catch((err) => {
              this.$Notice.warning({title:"提示",desc:"获取装备包裹失败,请联系管理员"});
            });
        },
      //捐献的确定
      changeSmelt() {
        this.$http
          .post(
            "/gameSect/playersConsignWare?charaId=" +
            this.getCookie("charaId") +
            "&packId=" +
            this.packItemId
          )
          .then((res) => {
            this.$Notice.success({title:res.data.msg});
            this.refreshPackage(); // 获取全部包裹
            //this.refreshUserInfo();
          })
          .catch((err) => {
            this.$Notice.warning({title:err.data.msg});
          });
      },
        addBoard(){
          this.boardEject = true;
          this.boardMsg = "";
        },
        sectBorad(){
          this.$http
            .get(
              "/gameSect/querySectBoardList/?charaId=" +
              this.getCookie("charaId")
            )
            .then((res) => {
              //this.$Notice.success({title:res.data.msg});
              this.sectBoardList=res.data.data;
            });
        },
        sectknapsack(index =1){
          //this.gameSectItemBo.name=name;
          this.$http
            .post(
              "/gameSect/getSectWare", {
          ...this.gameSectItemBo,
              charaId: this.getCookie("charaId"),
              page:index,
            }).then((res) => {
              this.sectknapsackList = res.data.rows;
              this.total = res.data.records
              //this.$Notice.success({title:res.data.msg});
            });
        },
       //藏宝阁
       selectbaogeList(){
         this.$http
           .post(
             "/gameSect/getSectSyntheticList/?charaId=" +
             this.getCookie("charaId")
           )
           .then((res) => {
             //this.$Notice.success({title:res.data.msg});
             this.sectBaoGeList=res.data.data;
           }).catch((err) => {
           this.$Notice.warning({title:"提示",desc:"藏宝阁封印"});
         });
       },
      //藏宝阁兑换
        synthesisItem(index) {
          this.item=this.sectBaoGeList[index];
          this.$http
            .post(
              "	/gameSect/breakThroughTheSect?charaId=" +
              this.getCookie("charaId") +
              "&syntheticId=" +
              this.item.syntheticId +
              "&syntheticNum=" +
              1
            )
            .then((res) => {
              this.$Notice.success({title:"提示",desc:res.data.msg});
              this.selectbaogeList();
            })
            .catch((err) => {
              this.$Notice.warning({title:"提示",desc:err.data.msg});
            });
        },
        //加成
        sectBuff() {
          this.$http
            .get(
              "/gameSect/getSectXinfaList/?charaId=" +
              this.getCookie("charaId")
            )
            .then((res) => {
              //this.$Notice.success({title:res.data.msg});
              this.sectBuffs=res.data.data;
            }).catch((err) => {
            this.$Notice.warning({title:"提示",desc:"无心法加成"});
          });
        },
        // 进入宗门界面
        sectBoundary() {
          this.$http
            .post("/gameSect/sectBoundary/?charaId=" + this.getCookie("charaId"))
            .then((res) => {
              if (res.data.data == "无宗门") {
                this.sectStatus = 0;
                this.sectList = {};
                this.sectList.sectDiscipleVoList = [{}, {}, {}];
                this.joinSect();
                this.$bus.$emit("sectStatusmsg", "无宗门");
              } else {
                this.sectEject2 = false;
                this.sectEject3=true;
                this.sectStatus = 1;
                this.sectList = res.data.data;
                //宗门弟子分页
                this.discipleTableData=this.sectList.sectDiscipleVoList;
                this.discipleTotal = this.discipleTableData.length
                let start = (this.discipleCurrentPage - 1) * this.disciplePageSize
                let end = this.discipleCurrentPage * this.disciplePageSize
                var temp = this.discipleTableData.slice(start, end) // 截取之后的数据
                this.discipleTempData = temp
                console.log(this.tableData)
                //留言板
                this.sectBorad();
                this.joinSect2();
                //宝库列表
                this.sectknapsack(1);
                //藏宝阁列表
                this.selectbaogeList();
                //心法列表
                this.querySectXinfaList();
                this.$bus.$emit("sectStatusMsg2", "有宗门");
              }
            })
            .catch((err) => {
              console.log(err, "进入宗门界面");
            });
        },
        joinSect2() {
          this.$http.post("/gameSect/getSectList").then((res) => {
            this.sectItemList2 = res.data.data;
          });
        },
        // 打开宗门列表
        joinSect() {
          this.sectEject2 = true;
          this.$http.post("/gameSect/getSectList").then((res) => {
            this.sectList2 = res.data.data;
          });
        },
        //sectXinfaList 宗门心法列表
        querySectXinfaList() {
          this.$http.post(
            "/gameSect/getDisXinfaList2/?charaId=" +
            this.getCookie("charaId")
          ).then((res) => {
            var resMap = res.data.data;
            if (resMap) {
              this.sectXinfaList = [];
              //遍历后台响应数据，构造柱状图数据源
              var count = 1;
              for (var key in resMap) {
                if(count==1){
                  this.sectXinfaName="心法"+key;
                  this.sectXinfaList=resMap[key];
                }else if(count==2){
                  this.sectXinfaName2="心法"+key;
                  this.sectXinfaList2=resMap[key];
                }else if(count==3){
                  this.sectXinfaName3="心法"+key;
                  this.sectXinfaList3=resMap[key];
                }
                count++;
              }
            }
          });
        },
        // 宗门列表里的加入按钮
        JoinTheSect(item) {
          this.$http
            .post(
              "/gameSect/playerJoinSect/?charaId=" +
              this.getCookie("charaId") +
              "&sectId=" +
              item.id
            )
            .then((res) => {
              this.$Notice.success({title:"提示",desc:res.data.msg});
              this.sectBoundary();
              this.refreshUserInfo(); // 获取用户 人物属性
              this.refreshUserInfoCache(); // 获取用户 基本活动属性
            });
        },
      // 宗门列表里的退出按钮
      deleTheSect() {
        this.$http
          .post(
            "/gameSect/exitSect/?charaId=" +
            this.getCookie("charaId")
          )
          .then((res) => {
            this.$Notice.success({title:"提示",desc:res.data.msg});
            this.sectBoundary();
            this.refreshUserInfo(); // 获取用户 人物属性
            this.refreshUserInfoCache(); // 获取用户 基本活动属性
          });
      },
      //弟子晋升
      disiplePromotion() {
        this.$http
          .post(
            "/gameSect/disiplePromotion/?charaId=" +
            this.getCookie("charaId")
          )
          .then((res) => {
            this.$Notice.success({title:"提示",desc:res.data.msg});
            this.sectBoundary();
            this.refreshUserInfoCache(); // 获取用户 基本活动属性
          });
      },
      //参与大比
      sectRegistCompe() {
        this.$http
          .post(
            "/gameLockDemon/sectRegistCompe/?charaId=" +
            this.getCookie("charaId")
          )
          .then((res) => {
            this.$Notice.success({title:"提示",desc:res.data.msg});
            //this.sectBoundary();
            //this.refreshUserInfoCache(); // 获取用户 基本活动属性
          });
      },
      // 打开队伍列表
        join() {
            this.armyListEject = true;
            this.$http.post("/gameAmry/getArmyList?armyName").then((res) => {
                this.armyList = res.data.data;
            });
        },

        // 队伍列表里的加入按钮
        JoinTheTeam(item) {
            this.$http
                .post(
                    "/gameAmry/playerJoinAmry/?charaId=" +
                    this.getCookie("charaId") +
                    "&amryId=" +
                    item.armyId
                )
                .then((res) => {
                    this.$Notice.success({title:"提示",desc:res.data.msg});
                    this.armyBoundary();
                    this.armyListEject = false;
                });
        },

        // 创建队伍
        establish() {
            this.armyEject = true;
        },

        // 队伍名字的确定
        changeEstablish() {
          if(!this.armyLevel){
            this.$Notice.warning({title:"提示",desc:"等级必须输入"});
            return;
          }
            this.$http
                .post(
                    "/gameAmry/playerCreateAmry/?charaId=" +
                    this.getCookie("charaId") +
                    "&armyName=" +
                    this.armyName+
                  "&armyLevel=" +
                  this.armyLevel+
                  "&armyType=" +
                  this.armyType
                )
                .then((res) => {
                    this.$Notice.success({title:"提示",desc:res.data.msg});
                    if (res.data.msg == "OK") {
                        this.armyBoundary();
                    }
                    console.log(res, "队伍名字的确定");
                });
        },

        // 退出队伍
        quitTheTeam() {
            this.$http
                .post("/gameAmry/exitAmry/?charaId=" + this.getCookie("charaId"))
                .then((res) => {
                    this.armyBoundary();
                    this.$Notice.success({title:"提示",desc:res.data.msg});
                });
        },

        // 踢出队伍失败
        kickOut(item) {
            this.$http
                .post(
                    "/gameAmry/kickOutAmry/?charaId=" +
                    this.getCookie("charaId") +
                    "&charaNo=" +
                    item.charaNo
                )
                .then((res) => {
                    this.armyBoundary();
                    this.$Notice.success({title:"提示",desc:res.data.msg});
                });
        },

        // 自动出售设置的获取
        getPackageBo() {
            this.$http
                .post(
                    "/gameMarket/getScreenPackage?charaId=" + this.getCookie("charaId")
                )
                .then((res) => {
                    this.gamePackageBo = res.data.data;
                    if (this.gamePackageBo.isOpen === null) this.gamePackageBo.isOpen = 0;
                    this.gamePackageBo.quality = this.gamePackageBo.quality
                        ? this.gamePackageBo.quality.split(",")
                        : [];
                })
                .catch((err) => {
                    this.$Notice.warning({title:"提示",desc:"自动出售设置获取列表失败,请联系管理员"});
                });
        },

        // 打开设置
        openSetEject() {
            this.setEject = true;
            this.getPackageBo(); //自动出售设置的获取
        },

        // 设置的确定
        changeSet() {
            if (!(this.gamePackageBo.minLevel >= 0)) {
                this.$Notice.warning({title:"提示",desc:"最低等级不能为空"});
                return;
            }
            if (!(this.gamePackageBo.maxLevel >= 0)) {
                this.$Notice.warning({title:"提示",desc:"最高等级不能为空"});
                return;
            }
            if (this.gamePackageBo.minLevel >= this.gamePackageBo.maxLevel) {
                this.$Notice.warning({title:"提示",desc:"最小等级不能超过最大等级"});
                return;
            }
            if (this.gamePackageBo.quality.length <= 0) {
                this.$Notice.warning({title:"提示",desc:"品质列表必须选择一个"});
                return;
            }

            this.$http
                .post("/gameMarket/setScreenPackage", {
                    ...this.gamePackageBo,
                    charaId: this.getCookie("charaId"),
                    quality: this.gamePackageBo.quality.join(","),
                })
                .then((res) => {
                    this.$Notice.success( {title:"提示",desc:res.data.data});
                })
                .catch((err) => {
                    this.$Notice.warning({title:"提示",desc:"设置失败"});
                });
        },
        _isMobile() {
          let flag = navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
          );
          return flag;
        },
        // 退出登录
        out() {
            this.$http
                .post("/gamepassport/logout?userId=" +
                    this.getCookie("userId"))
                .then((res) => {
                    this.$Notice.success({title:"提示",desc:res.data.msg});
                })
                .catch((err) => {
                    this.$Notice.warning({title:"提示",desc:"退出登录失败,请联系管理员"});
                });

            this.$bus.$emit("tcdlMsg", "退出登录那里发送过来的");
            this.$router.push({ name: "Login" });
        },

        // 打开攻略
        openStrategy() {
            this.strategy = true;
        },
        // 打开频道
        openPindao() {
          this.pindao = true;
        },
        // 打开切换账号页面
        openSelectChara() {
          this.selectChara = true;
        },
        openZhuti() {
          this.limflag = true;
        },
        // 打开修改密码
        changePas() {
            this.originalPas = "";
            this.newPas = "";
            this.confirmPas = "";
            this.pasEject = true;
        },

        // 修改密码弹出框的确认
        confirmPassword() {
            this.$http
                .post(
                    "/gamepassport/updatePwd?userId=" +
                    this.getCookie("userId") +
                    "&originalPwd=" +
                    this.originalPas +
                    "&newPwd=" +
                    this.newPas +
                    "&confirmPwd=" +
                    this.confirmPas
                )
                .then((res) => {
                    this.$Notice.success({title:"提示",desc:res.data.msg});
                })
                .catch((err) => {
                    this.$Notice.warning({title:"提示",desc:"修改密码失败,请联系管理员"});
                });
        },

        // 打开兑换码
        openExchange() {
            this.exchangeEject = true;
            this.exchange = "";
        },
        openTradingBankEject() {
            this.tradingBankEject = true
            setTimeout(() => {
                this.$nextTick(() => {
                    this.$refs.tradingBank.getTradingBankList();
                })
            }, 1000)
        },
        openLockDemonTowerEject() {
            this.lockDemonTowerEject = true
            setTimeout(() => {
                this.$nextTick(() => {
                    this.$refs.lockDemonTower.getMapList();
                })
            }, 1000)
            // this.$http.get("gameBussiness/getBussinessList?page=" + 1 + "&pageSize=" + 20 + '&bussinessName' + '').then((res) => {
            //     console.error(res.data.rows)
            //     this.tradingBankList = res.data.rows;
            //     this.tradingBankEject = true
            // })
            // .catch((err) => {
            //     this.$Notice.warning({title:"获取黑市失败,请联系管理员"});
            // });
        },

        // 打开真灵
        openPets() {
            this.PetsEject = true;
            this.$http
                .post("/gameAura/getCharaPet?charaId=" + this.getCookie("charaId"))
                .then((res) => {
                    this.PetsList = res.data.data;
                    this.PetsList.forEach(d => {
                        // if (d.auraName == '炽焰狼') {
                        //     d.auraIcon = 'https://image8.cdn2.seaart.ai/2023-08-20/14895646759741445/cf76999a4e2f0b1292fae1028b336054ed2718eb_high.webp'
                        // } else if (d.auraName == '三眼灵猴') {
                        //     d.auraIcon = 'https://image2.cdn2.seaart.ai/2023-07-15/45424216264773/b073af8d407351509583f8c3d18e5d6cdfe014a4_high.webp'
                        // } else if (d.auraName == '白泽') {
                        //     d.auraIcon = 'https://image1.cdn2.seaart.ai/2023-09-14/17164851793156101/d6b47ec23aca10d2a11515c572a0fe46ea298546_high.webp'
                        // } else {
                        //     d.auraIcon = 'https://image2.cdn2.seaart.ai/2023-09-24/18026210080650245/5884d0a350e8de9ff67c896ef91cf2a188bb9f42_high.webp'
                        // }
                    })
                })
                .catch((err) => {
                    this.$Notice.warning({title:"提示",desc:"真灵获取失败,请联系管理员"});
                });
        },
        // 真灵放生 确认框
        ReleaseZhen(item) {
          this.zhenitem=item;
          this.releaseEject=true;
        },
        // 真灵放生
        Release() {
            if (this.zhenitem.auraStatus == 1) {
                this.$Notice.warning({title:"提示",desc:"真灵出战中, 不能放生"});
                return
            }
            this.$http
                .post("/gameAura/goSpiritRelease?charaId=" + this.getCookie("charaId") + "&petId=" + this.zhenitem.auraId)
                .then((res) => {
                    this.$Notice.success({title:"提示",desc:res.data.msg});

                    // 真灵放生重新获取
                    this.$http
                        .post("/gameAura/getCharaPet?charaId=" + this.getCookie("charaId"))
                        .then((res) => {
                            this.PetsList = res.data.data;
                        })
                        .catch((err) => {
                            this.$Notice.warning({title:"提示",desc:"真灵获取失败,请联系管理员"});
                        });
                })
                .catch((err) => {
                    this.$Notice.warning({title:"提示",desc:"真灵放生失败,请联系管理员"});
                });
        },
        // 真灵出战
        goToWar(item) {
            let auraStatus = item.auraStatus == 0 ? 1 : 0
            this.$http
                .post("/gameAura/goToWarByAure?charaId=" + this.getCookie("charaId") + "&petId=" + item.auraId + "&aureStatus=" + auraStatus)
                .then((res) => {
                    this.$Notice.success({title:"提示",desc:res.data.msg});
                    this.openPets()
                })
                .catch((err) => {
                    this.$Notice.warning({title:"提示",desc:"真灵出战失败,请联系管理员"});
                });
        },

        cs() { },

        // 兑换码确定
        changeExchange() {
            this.$http
                .post(
                    "/gamepassport/exchangeCode?charaId=" +
                    this.getCookie("charaId") +
                    "&exchangeCode=" +
                    this.exchange
                )
                .then((res) => {
                    this.$Notice.warning({title:"提示",desc:res.data.msg});
                })
                .catch((err) => {
                    this.$Notice.warning({title:"提示",desc:err.data.msg});
                });
            this.$bus.$emit("dhmMsg", "兑换码那里发送过来的");
        },
        // 留言确定
        changeBoard() {
          this.$http
            .post(
              "/gameSect/addSectBoard?charaId=" +
              this.getCookie("charaId") +
              "&msg=" +
              this.boardMsg
            )
            .then((res) => {
              this.$Notice.warning({title:"提示",desc:res.data.msg});
              this.sectBorad();
            })
            .catch((err) => {
              this.$Notice.warning({title:"提示",desc:err.data.msg});
            });
          this.$bus.$emit("dhmMsg", "留言那里发送过来的");
        },
        signIn() {
            this.$http
                .post(
                    "/gamepassport/signInDaily?charaId=" +
                    this.getCookie("charaId") +
                    "&signType=" +
                    1
                )
                .then((res) => {
                    this.$Notice.warning({title:"提示",desc:res.data.data });
                })
                .catch((err) => {
                    this.$Notice.warning({title:"提示",desc:"签到失败,请联系管理员"});
                });

            this.$bus.$emit("dhmMsg", "兑换码 签到那里发送过来的");
        },
      async startTheBattle() {
        try {
          const res = await this.$http.post(
            `gameLockDemon/playerDuelRecord?${qs.stringify({
              charaId: this.getCookie("charaId"),
              sectDisId: this.discipleId,
            })}`
          );

          if (res.data.msg != 'OK') {
            this.$Notice.warning({title:"提示",desc:res.data.msg});
            return
          }
          const body = res.data;

          if (body.status == 205) {
            this.$Notice.warning(body.msg);
            // await sleep(6000);
            // this.startTheBattle();
            return;
          }

          const combatResults = body.data
          // 按顺序播报所有的战斗结果
          for (let i = 0; i < combatResults.length; i++) {
            this.monsterList = combatResults[i].gameMonDieList; // 怪物信息
            this.monsterList.forEach((m) => (m.maxLife = m.health));
            if (this.teamStatus != 1) {
              this.gamePetVOList = combatResults[i].gamePetVO; // 怪物信息
              if (combatResults[i].gamePetVO) {
                combatResults[i].gamePetVO = {
                  health: combatResults[i].gamePetVO.life,
                  name: combatResults[i].gamePetVO.auraName,
                  ...combatResults[i].gamePetVO
                }
                this.gameCharacterVO = [combatResults[i].gameCharacterVO, combatResults[i].gamePetVO]; // 人物 加宠物信息信息
                this.gameCharacterVO.forEach((m) => (m.formerHealth = m.health));
              } else {
                this.gameCharacterVO = [combatResults[i].gameCharacterVO]; // 人物加信息
                //this.gameCharacterVO.forEach((m) => (m.maxLife = m.health));
              }
            }
            //清空战斗统计信息
            this.battleTotal=false;
            this.battleTotalList=[];
            await this.boardcastCombatResult(combatResults[i]);
          }
        } catch (err) {
          this.$Notice.warning({title:"提示",desc:"切磋结束"});
        }
      },

        // 播报战斗返回的日志
        async boardcastCombatResult(result) {
          let combatInfo = result.combatInfo;
          for (let i = 0; i < combatInfo.length; i++) {
            // 每条记录的输出相隔 1.5 秒
            await sleep(1500);
            const record = combatInfo[i];
            //记录战斗统计
            if(this.battleTotalList.length>0){
              var falg=false;
              for (let i = 0; i < this.battleTotalList.length; i++) {
                if(this.battleTotalList[i].name===record.attacker){
                  this.attackTotalDam(record,i);
                  falg=true;
                }
              }
              if(!falg){
                this.attackTotalDam(record,null);
              }
            }else{
              this.attackTotalDam(record,null);
            }
            const targets = this.monsterList.filter(
              (m) => m.name == record.hinjured
            );
            if (targets.length > 0 && targets[0].health >=0) {
              targets[0].health = record.surplusHealth;
            }

            if (this.teamStatus != 1) {
              const targets1 = this.gameCharacterVO.filter(
                (m) => m.name == record.hinjured
              );
              if (targets1.length > 0) {
                targets1[0].health = record.surplusHealth;
              }
            }
            // 1 物理伤害 2灵力伤害 3持续伤害 4恢复血量
            // console.log(record, "战斗日志");
            if (record.hurtType == 5) {
              record.type = "gain";
            } else {
              record.type = "combat";
            }
            this.addRecord(record);
          }
          // 额外增加一个战斗结果的消息记录
          if (result.reHealth <= 0) {
            this.addRecord({
              type: "result",
              result: "战斗失败",
            });
            this.battleTotal=true;
          } else {
            // 物品列表
            // const goods = result.gameItemsList.map((val) => {
            //   return val.itemName;
            // });
            // const droppedGood = goods.length > 0;
            this.addRecord({
              type: "result",
              result: "战斗成功",
              exp: "获得" + result.dropExp + "经验;",
              goods: "物品:" + "无",
              reHealth: result.reHealth,
              reMana: result.reMana,
            });
            this.battleTotal=true;
            // if (droppedGood) {
            //   // 通知神通刷新检查
            //   this.$bus.$emit("skillMsg", "锁妖塔发送过来的");
            //   this.$bus.$emit("synthesisMsg", "锁妖塔发送过来的");
            // }
          }
        },
        attackTotalDam(record,value){
          var battle={
            name: "",
            damage: 0,
            attack: 0,
            lidao: 0,
            lingli: 0,
            zhiliao: 0,
            huilan: 0,
            sustained: 0,
            counterattack: 0,
            control: 0,
          };
          if(value!=null){
            battle=this.battleTotalList[value];
          }
          //名称
          battle.name=record.attacker;
          //伤害  record.hurtNum;
          if(record.hurtType==1){
            //hurtType 1 物理伤害
            battle.damage = battle.damage + record.hurtNum;
            if(record.isSkill==0){
              //普攻
              battle.attack = battle.attack + record.hurtNum;
            }else{
              //神通
              battle.lidao = battle.lidao + record.hurtNum;
            }
          }else if(record.hurtType==2){
            //hurtType 2 灵力伤害
            battle.damage = battle.damage + record.hurtNum;
            if(record.isSkill==0){
              //普攻
              battle.attack = battle.attack + record.hurtNum;
            }else{
              //神通
              battle.lingli = battle.lingli + record.hurtNum;
            }
          }else if(record.hurtType==3){
            //hurtType 3 持续伤害
            battle.damage = battle.damage + record.hurtNum;
            battle.sustained = battle.sustained + record.hurtNum;
          }else if(record.hurtType==4){
            //hurtType 4 反击伤害
            battle.counterattack = battle.counterattack + record.hurtNum;
          }else if(record.hurtType==5){
            //hurtType 5 恢复血量
            battle.zhiliao = battle.zhiliao + record.hurtNum;
          }else if(record.hurtType==6){
            //hurtType 6 回复蓝量
            battle.huilan = battle.huilan + record.hurtNum;
          }else if(record.hurtType==7){
            //hurtType 7 回复血量和蓝量
            battle.zhiliao = battle.zhiliao + record.hurtNum;
          }else if(record.hurtType==9){
            //hurtType 9 持续恢复血量
            battle.zhiliao = battle.zhiliao + record.hurtNum;
          }else if(record.hurtType==10){
            //hurtType 10 特殊技能描述
            battle.control = battle.control + 1;
          }
          if(record.hinjuredConmbatList!=null&&record.hinjuredConmbatList.length>0){
            for (let i = 0; i < record.hinjuredConmbatList.length; i++) {
              if(record.hinjuredConmbatList[i].hurtType===10){
                battle.control = battle.control + 1;
              }else {
                //持续技能伤害 敌人给你造成的 需要加载其他的地方
                for (let t = 0; t < this.battleTotalList.length; t++) {
                  if(this.battleTotalList[t].name===record.hinjuredConmbatList[i].attacker){
                    if(record.hinjuredConmbatList[i].hurtType===9){
                      this.battleTotalList[t].zhiliao = this.battleTotalList[t].zhiliao + record.hinjuredConmbatList[i].hurtNum;
                    }else{
                      this.battleTotalList[t].sustained = this.battleTotalList[t].sustained + record.hinjuredConmbatList[i].hurtNum;
                    }
                  }
                }
              }
            }
          }
          if(value!=null){
            this.battleTotalList[value]=battle;
          }else{
            this.battleTotalList.push(battle);
          }
        },
        addRecord(record) {
          this.recording.push(record);
          // 战斗记录超过一定条数时移除一部分
          if (this.recording.length >= 200) {
            this.recording.splice(0, 100);
          }
        }
    },
};
</script>
<style>
.headersMain {

}
.headers {
    height: 60px;
    line-height: 60px;
    min-width: 640px;
    color: #fff;
    /* backdrop-filter: blur(20px); */
    background: rgba(95, 95, 95, 0.3);
    box-shadow: 3px 3px 6px 3px rgba(0, 0, 0, 0.3);
    margin-bottom: 10px;
    border-radius: 4px;
}

.head-cen {
    width: 98%;
    margin: 0 auto;
    overflow: hidden;
}
.head-cen2 {
  height: 30px;
  line-height: 30px;
  width: 98%;
  margin: 0 auto;
  overflow: hidden;
}
.heade-left {
    float: left;
    background-color: #515a6e;
}
.heade-left ul,
.heade-right ul {
    overflow: hidden;
}
.heade-left ul li,
.heade-right ul li {
    float: left;
    height: 60px;
    padding: 0 10px;
    cursor: pointer;
}
.heade-left ul li:hover,
.heade-right ul li:hover {
    background: #363e4f;
    transition: all 0.6s;
}
.heade-right {
    float: right;
}

.heade-left2 {
  float: left;
  background-color: #FFFFFF;
}
.heade-left2 ul,
.heade-right2 ul {
  overflow: hidden;
}
.heade-left2 ul li,
.heade-right2 ul li {
  float: left;
  height: 60px;
  padding: 0 10px;
  cursor: pointer;
}
.heade-left2 ul li:hover,
.heade-right2 ul li:hover {
  color: #2d8cf0;
  border-bottom: 3px solid #2d8cf0;
}
.heade-right2 {
  float: right;
}

.pasEject /deep/ .ivu-input-wrapper {
    margin-bottom: 20px;
}
.mapLoots p {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    line-height: 2;
}

/* 重要更新或者文字突出 */
.importantFont {
    color: #007eff;
    font-size: 16px;
}

.importantFontRed {
    color: #ff004c;
    font-size: 16px;
}

/* 组队列表 */
.organizeEject /deep/ .ivu-modal-body {
    /* display: flex;
  justify-content: space-between; */
}

.organizeList {
    margin-bottom: 15px;
    overflow: hidden;
    padding: 10px;
}

.organizeList_face {
    width: 100px;
    height: 100px;
    display: block;
    /* border: 1px dashed skyblue; */
    margin: 0 auto 15px;
    border-radius: 5%;
   /* box-shadow: 0px 0px 10px #00adff;*/
    object-fit: cover; /* 覆盖容器，可能会裁剪部分图片 */
    object-position: center; /* 图片的对齐方式 */
}

.organizeList_face::before {
    line-height: 100px;
}

.organizeList_face + span {
    position: absolute;
    font-size: 20px;
    right: 0;
    top: -10px;
    cursor: pointer;
    color: red;
}

.organizeList_name {
    text-align: center;
    font-size: 18px;
    float: left;
    margin-left: 20px;
}

/* 真灵列表  加c是class的意思 */
.PetsListC {
    font-family:'思源黑体', sans-serif ;
    overflow: hidden;
}
.PetsListC > img {
    float: left;
}
.PetsListC .ivu-col{
  border: 1px solid #abb6c0;
  height: 30px;
  line-height: 30px;
  text-indent: 1em;
}

.PetsListC > div {
    float: left;
    margin-left: 15px;
    font-size: 15px;
    width: 482px;
}

.PetsListC > div > span {
    padding: 0 5px;
}

.PetsListC > div p {
  /*  margin-top: 15px;*/
}

.PetsListC > div p span {
    display: inline-block;
    width: 102px;
}
.petsbtn {
    margin-top: 15px;
}
</style>

<style scoped>
* {
  font-family: '思源黑体', sans-serif ;
}
label {
  content: attr(data-numbers);
  font-family: 'Roboto', sans-serif !important; /* 为数字设置字体 */
}
.knapsack > div {
  margin-right: 20px;
  margin-bottom: 20px;
}

.Equipment p {
  color: white;
}

/* 地图和战斗场景 */
.monster {
  display: flex;
  justify-content: space-between;
  /* margin-bottom: 40px; */
  margin-bottom: 8px;
  margin-top: 8px;
}
.monstercenter {
  justify-content: center;
}
/*  战斗场景  */
.recording {
  max-height: 174px;
  overflow: auto;
  transition: all 0.4s;
}
</style>



// WEBPACK FOOTER //
// src/components/headers.vue